import React from "react";
import BlogIcon from "@/assets/svgs/blog-icon.svg";
import Box from "@sendsprint/ui-react/components/box";
import Typography from "@sendsprint/ui-react/components/typography";

interface Props {
  text?: string;
}

const BlogEmptyContent = ({ text = "No blog content found" }: Props) => {
  return (
    <Box className="ss:flex ss:flex-col ss:gap-5 ss:items-center ss:col-span-full ss:py-40">
      <BlogIcon className="ss:w-50 ss:h-50" />
      <Typography as="h5" variant="h5" className="ss:mb-4 ss:font-semibold">
        {text}
      </Typography>
    </Box>
  );
};

export default BlogEmptyContent;
